import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CheckboxModel } from 'src/app/shared/models/common.model';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-client-credits',
  templateUrl: './client-credits.component.html',
  styleUrls: ['./client-credits.component.scss'],
})
export class ClientCreditsComponent implements OnInit {

  creditList: any;
  index: number;
  creditInfo: any;
  formGroup: FormGroup;
  newType: any;
  newNumber: any;
  newAmount: any;
  flag = false;
  showOptions: boolean;
  edit = false;
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private bitacora: BitacoraService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private productService: ProductsService,
    private parameterService: ParametersService,

  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
  }

  ngOnInit() {
    this.creditList = this.abreCuentasService.getCreditList();
    this.index = this.abreCuentasService.getCreditIndex();
    this.creditInfo = this.abreCuentasService.getCreditInfo();
    this.edit = this.abreCuentasService.getEditCredit();
    const deleteCredit = this.abreCuentasService.getDeleteCredit();
    if (deleteCredit) {
      const index = this.creditList.indexOf(this.creditList[this.index]);
      this.creditList.splice(index, 1);
      this.abreCuentasService.setCreditInfo(this.creditList);
      this.abreCuentasService.setEditCredit(false);
      this.abreCuentasService.setDeleteCredit(false);
      this.edit = false;
    }
    if (this.edit) {
      this.creditList[this.index] = {
        type: this.creditInfo.type,
        number: this.creditInfo.number,
        amount: this.creditInfo.amount,
      };
      this.abreCuentasService.setCreditInfo(this.creditList);
      this.abreCuentasService.setEditCredit(false);
    }
    if (this.index >= 0 && this.creditInfo.type && !this.edit) {
      this.creditList.push({ type: this.creditInfo.type, number: this.creditInfo.number, amount: this.creditInfo.amount });
      this.abreCuentasService.setCreditInfo(this.creditList);
    }
    if (this.index >= 15) {
      this.flag = true;
    } else {
      this.flag = false;
    }
    console.log(this.creditList);
  }

  addCredit() {
    this.index++;
    this.abreCuentasService.setCreditIndex(this.index);
    this.navigationService.nextStep('201');
  }

  editCredit(i: number) {
    this.abreCuentasService.setCreditIndex(i);
    this.abreCuentasService.setEditCredit(true);
    this.navigationService.nextStep('201');
  }

  next() {
    this.navigationService.nextStep('200');
  }

}
